export enum ResourceDataModelType {
  Organization = 'Organization',
  Event = 'Event',
}